import { Module } from 'shared/core';
import { Injectable } from 'injection-js';
import { AjaxForm } from 'shared/lib';
import { Helpers } from 'shared/misc/helpers';

@Injectable()
export class ForgottenModule extends Module {
  private currencySymbol: string = $('.product-price').data('currency');

  public init(): void {
    AjaxForm.createGeneral('form.expected_item_form', (response, form) => {
      if (response.success) {
        form.find('.add_to_basket').addClass('button_success').prop('disabled', true).text('Added!');
        form.find('.dd-container').prepend('<div class="disabled-container-spinner"></div>');
        form.find('.dd-select').addClass('disabled');

        $('.next-basket').removeClass('hidden');
        $('.next-page').addClass('hidden');
      } else {
        form.find('.add_to_basket').prop('disabled', false);
      }
    }, (form) => {
      let subSchoolItemId= form.find('input.sub_school_item_id').val() as string;

      if (subSchoolItemId.length == 0) {
        return false;
      }

      form.find('.add_to_basket').prop('disabled', true);
      return true;
    });

    $('.size-select select').each((i, el) => {
      ($(el) as any).sbsizing({
        maxHeight: 320,
        onSelected: () => {
          this.changeSize(el);
        },
      });

    });

    $('.product-price').removeClass('hidden');
  }

  private changeSize(el: HTMLElement) {
    const row: HTMLElement = el.closest('.expected_item_row');

    const option = $(el).find('option:selected');
    const fullPrice = option.data('fullPrice');
    const promotionalPrice = option.data('promotionalPrice');

    $(row).find('input.sub_school_item_id').val(option.val());

    this.changePrice(row, fullPrice, promotionalPrice);
  }

  private changePrice(row: HTMLElement, fullPrice: number, promotionalPrice: number): void {
    if (fullPrice === undefined) {
      $(row).find('.price-offer').hide();
      $(row).find('.price-current').hide();
    } else if (promotionalPrice != fullPrice) {
      $(row).find('.price-offer').show();
      $(row).find('.price-current').hide();

      $(row).find('.price-offer-old').html(Helpers.currencyFormatter(fullPrice, this.currencySymbol));
      $(row).find('.price-offer-new').html(Helpers.currencyFormatter(promotionalPrice, this.currencySymbol));
    } else {
      $(row).find('.price-offer').hide();
      $(row).find('.price-current').show();
      $(row).find('.price-full').html(Helpers.currencyFormatter(fullPrice, this.currencySymbol));
    }
  }
}
